import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { HAccordion } from './HAccordion';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage, AccordionListModule } from '~/schemes';

/** アコーディオンリストモジュール */
export const HAccordionList = tsx.component({
  name: 'HAccordionList',
  functional: true,

  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<
          AccordionListModule['properties'],
          AvailableLanguage
        >
      >,
      required: true,
    },
  },

  render(h, { props }): VNode {
    return (
      <div class="v-accordion-list-module">
        {props.value.items.map((item) => (
          <HAccordion key={item.key} value={item.properties} />
        ))}
      </div>
    );
  },
});
